module.exports = __webpack_public_path__ + "img/left-arrow.963ec438.svg";